import { ContactLayout } from "component/contact-us";

export function ContactUs() {
  return <ContactLayout />;
}
